<template>
  <collapsed-section title="Contract" :open="true" class="mb-5" v-if="contract">
    <error-banner v-if="error" :message="error"/>
    <template v-else>
      <pdf-container/>
      <signature-pad v-if="signatureRequired"/>
    </template>
  </collapsed-section>
</template>

<script>
import { mapMutations } from 'vuex'
import { WebApi } from '@/services/WebApi'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import PdfContainer from './PdfContainer.vue'
import SignaturePad from './SignaturePad.vue'
import ErrorBanner from '../../ErrorValidation/ErrorBanner.vue'
import CollapsedSection from '../../Layout/CollapsedSection.vue'

export default {
  name: 'Contract',
  mixins: [ClientOnboardingInviteCacheMixin],
  data () {
    return {
      error: '',
      loading: false,
      contract: null
    }
  },
  computed: {
    signatureRequired () {
      return !!this.contract && this.contract.signatureRequired
    }
  },
  watch: {
    contractStatusCreated (value) {
      if (value) {
        this.tryViewContract()
      }
    },
    contractCompleted (value) {
      if (value) {
        this.tryCompleteContract()
      }
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setContractCompleted'
    ]),
    tryFetchContract () {
      const self = this
      if (self.loading) {
        return
      }
      self.error = ''
      self.loading = true
      WebApi.get('ClientOnboardingInvite/' + self.inviteId + '/Contract')
        .then(response => { self.contract = response.data })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    },
    tryCompleteContract () {
      const self = this
      if (self.loading) {
        return
      }
      self.error = ''
      self.loading = true
      WebApi.put('ClientOnboardingInvite/' + self.inviteId + '/Contract/Complete')
        .then(response => { self.contract = response.data })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            self.tryFetchClientOnboardingInvite()
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
        .finally(() => { self.loading = false })
    }
  },
  components: {
    'pdf-container': PdfContainer,
    'signature-pad': SignaturePad,
    'error-banner': ErrorBanner,
    'collapsed-section': CollapsedSection
  },
  created () {
    this.tryFetchContract()
  }
}
</script>
